import { autocomplete } from "@services/axios";
import React from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";

function AISelect({
  selectedValue,
  setSelectedValue,
  label,
  route,
  isDisabled = false,
  className = "",
  height = 50, // ✅ new optional prop, default stays same as current
  menuPlacement = "bottom"
}) {
  const customTheme = (theme) => ({
    ...theme,
    spacing: {
      ...theme.spacing,
      controlHeight: height, // optional: keep minimum usable height
      baseUnit: 5,
    },
  });
const { t } = useTranslation();
  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: `${height}px`, // ✅ dynamically applied
      border: "1px solid #ced4da",
      borderRadius: "0.5rem",
      boxShadow: "none",
      paddingLeft: "10px",
      fontSize: "1rem",
      backgroundColor: "#fff",
      color: "#000",
      "&:hover": {
        borderColor: "var(--primary-blue)",
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const loadRemoteOptions = async (inputValue) => {
    if (!inputValue) return [];
    return await autocomplete(route, inputValue);
  };

  return (
    <AsyncSelect
      theme={customTheme}
      cacheOptions
      defaultOptions
      isClearable
      value={selectedValue}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.name}
      onChange={setSelectedValue}
      loadOptions={loadRemoteOptions}
      placeholder={label}
      isDisabled={isDisabled}
      loadingMessage={() => t("fetchingResults")}
      noOptionsMessage={({ inputValue }) =>
        inputValue ? t("noResultsFound") : t("startTypingToSearch")
      }
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={customStyles}
      menuPlacement={menuPlacement}
      menuShouldScrollIntoView={true}
    />
  );
}

export default AISelect;
